import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Button } from "@mui/material";
import MDBox from "components/MDBox";
import MDAlert from "../../components/MDAlert";
import MDTypography from "../../components/MDTypography";
import { AuthContext } from "../../context";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import GenericForm from "../genericForm";

function YardAdd() {
	const authContext = useContext(AuthContext);
	const navigate = useNavigate();
	const [data] = useState(null);
	const [error] = useState("");

	const inputFields = [
		{
			type: "text",
			name: "name",
			label: "Nome cantiere",
		},
		{
			type: "text",
			name: "external_code",
			label: "Codice commessa",
		},
		{
			type: "text",
			name: "client",
			label: "Committente",
		},
		{
			type: "textarea",
			name: "description",
			label: "descrizione cantiere",
			rows: 5,
		},
		{
			type: "map",
			name: "location",
			label: "Posizione geografica",
		},
	];

	const requiredFields = [
		{ name: "name", nameDiplayed: "nome del cantiere" },
		{ name: "location", nameDiplayed: "posizione del cantiere" },
		{ name: "external_code", nameDiplayed: "codice commessa" },
		{ name: "client", nameDiplayed: "committente" },
	];

	return (
		<DashboardLayout>
			{authContext.hasAuth("ADD_AREE") ? (
				<>
					<DashboardNavbar />
					<MDBox pt={6} pb={3}>
						<Button variant="contained" color="primary" onClick={() => navigate("/yard-managment")} sx={{ mt: 2, alignSelf: "center", minWidth: "100px", color: "#ffffff", marginBottom: "30px" }}>
							Torna alla tabella
						</Button>
						{error !== "" ? <Alert severity="error">{error}</Alert> : <GenericForm authModelName={"AREE"} inputFields={inputFields} requiredFields={requiredFields} url="/area-management/" old_data={data} useAPI={true} redirectOnSuccess="/yard-managment/edit" />}
					</MDBox>
				</>
			) : (
				<MDAlert color="error" dismissible>
					<MDTypography variant="body2">You don't have permission to access this page</MDTypography>
				</MDAlert>
			)}
		</DashboardLayout>
	);
}

export default YardAdd;
